import _cloneDeepWith from 'lodash/cloneDeepWith';
import _cloneDeep from 'lodash/cloneDeep';
import _isEqual from 'lodash/isEqual';

const PROPERTIES_TO_BE_IGNORED = ['index', 'columnIdx', 'elmIdx'];

// cloneDeep and cloneDeepWith otherwise it's going to change the current object
const omitDeep = (object, excludeKeys) => _cloneDeepWith(_cloneDeep(object), (value) => {
    if (value && typeof value === 'object') {
        excludeKeys.forEach((key) => {
            delete value[key];
        });
    }
});

/**
 * This function returns if two sets of blocks are the same excluding indexes
 * @param {object} A - Blocks data A
 * @param {object} B - Blocks data B
 * @return {object} - whether or not blocks are equal
 */
export default (A, B) => {
    if (!A || !B) {
        return false;
    }

    return _isEqual(omitDeep(A, PROPERTIES_TO_BE_IGNORED), omitDeep(B, PROPERTIES_TO_BE_IGNORED));
};
